import React from 'react';

const CurrencyChipContext = React.createContext({});

export default CurrencyChipContext;
